import {
  ADDCART,
  ADDPRODUCT,
  DECREASEQUANTITY,
  DELETEPRODUCTCART,
  INCREASEQUANTITY
} from "./actionTypes";
import { initialState } from "./initialState";

export const nextProductId = (products) => {
  const maxId = products.reduce(
    (maxId, product) => Math.max(+product?.productId, +maxId),
    -1
  );
  return +maxId + 1;
};

export const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDCART:
      const productItem = action.payload;

      return {
        ...state,
        products: state?.products.map((product) => {
          if (product.productId !== productItem.productId) {
            return product;
          }
          return {
            ...product,
            quantity: +productItem.quantity - 1,
            totalSelectQuntity:
              product.totalSelectQuntity != null
                ? +product.totalSelectQuntity + 1
                : 1,
          };
        }),
        totalQuntity: +state?.totalQuntity + 1,
      };
    case ADDPRODUCT:
      return {
        ...state,
        products: [
          ...state?.products,
          { ...action.payload, productId: nextProductId(state?.products) },
        ],
      };

    case INCREASEQUANTITY:
      return {
        ...state,
        products: state?.products.map((product) => {
          if (product.productId !== action.payload.productId) {
            return product;
          }
          return {
            ...product,
            quantity: +product?.quantity > 0 && +product?.quantity - 1,
            totalSelectQuntity: +product.totalSelectQuntity + 1,
          };
        }),
        totalQuntity: +state?.totalQuntity + 1,
        subTotalBills: action.payload.price * action.payload.totalSelectQuntity,
      };

    case DECREASEQUANTITY:
      return {
        ...state,
        products: state?.products.map((product) => {
          if (product.productId !== action.payload.productId) {
            return product;
          }
          return {
            ...product,
            quantity: +product?.quantity + 1,
            totalSelectQuntity: +product.totalSelectQuntity - 1,
          };
        }),
        totalQuntity: +state?.totalQuntity - 1,
        subTotalBills: action.payload.price * action.payload.totalSelectQuntity,
      };

    case DELETEPRODUCTCART:
      return {
        ...state,
        products: state?.products.map((product) => {
          if (product.productId !== action.payload.productId) {
            return product;
          }
          return {
            ...product,
            quantity: +product?.quantity + +product?.totalSelectQuntity,
            totalSelectQuntity: 0,
          };
        }),
        totalQuntity: +state?.totalQuntity - +action.payload.totalSelectQuntity,
        subTotalBills: action.payload.price * action.payload.totalSelectQuntity,
      };

    default:
      return state;
  }
};
